import styled, { css } from "styled-components";

import type { Joint } from "api/types/GetActivityLibraryEntriesArgs";

export type JointType = Exclude<Joint, "jaw" | "spine" | "upper_back"> | "other";

export const JointsGroup = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  max-width: 800px;
`;

export const JointButton = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  width: 130px;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.redesign.b100};
  font-size: 16px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.colors.redesign.db30};
  border-radius: 8px;
  cursor: pointer;

  ${({ theme }) => theme.belowBreakpoint} {
    width: calc(50% - 42px);
  }

  ${({ $active }) =>
    $active &&
    css`
      background: ${({ theme }) => theme.colors.redesign.b100};
      color: ${({ theme }) => theme.colors.white};
    `}
`;
